import _indexOf from "lodash/indexOf";
import router from '@/router'
import store from '@/stores/store.js'
import universes from '@s/universes.js'

export default {

    sha1(msg) {

        var blockstart;
        var i, j;
        var W = new Array(80);
        var H0 = 0x67452301;
        var H1 = 0xEFCDAB89;
        var H2 = 0x98BADCFE;
        var H3 = 0x10325476;
        var H4 = 0xC3D2E1F0;
        var A, B, C, D, E;
        var temp;
        msg = this._Utf8Encode(msg);
        var msg_len = msg.length;
        var word_array = new Array();
        for (i = 0; i < msg_len - 3; i += 4) {
            j = msg.charCodeAt(i) << 24 | msg.charCodeAt(i + 1) << 16 |
                msg.charCodeAt(i + 2) << 8 | msg.charCodeAt(i + 3);
            word_array.push(j);
        }
        switch (msg_len % 4) {
            case 0:
                i = 0x080000000;
                break;
            case 1:
                i = msg.charCodeAt(msg_len - 1) << 24 | 0x0800000;
                break;
            case 2:
                i = msg.charCodeAt(msg_len - 2) << 24 | msg.charCodeAt(msg_len - 1) << 16 | 0x08000;
                break;
            case 3:
                i = msg.charCodeAt(msg_len - 3) << 24 | msg.charCodeAt(msg_len - 2) << 16 | msg.charCodeAt(msg_len - 1) << 8 | 0x80;
                break;
        }
        word_array.push(i);
        while ((word_array.length % 16) != 14) word_array.push(0);
        word_array.push(msg_len >>> 29);
        word_array.push((msg_len << 3) & 0x0ffffffff);
        for (blockstart = 0; blockstart < word_array.length; blockstart += 16) {
            for (i = 0; i < 16; i++) W[i] = word_array[blockstart + i];
            for (i = 16; i <= 79; i++) W[i] = this._rotate_left(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16], 1);
            A = H0;
            B = H1;
            C = H2;
            D = H3;
            E = H4;
            for (i = 0; i <= 19; i++) {
                temp = (this._rotate_left(A, 5) + ((B & C) | (~B & D)) + E + W[i] + 0x5A827999) & 0x0ffffffff;
                E = D;
                D = C;
                C = this._rotate_left(B, 30);
                B = A;
                A = temp;
            }
            for (i = 20; i <= 39; i++) {
                temp = (this._rotate_left(A, 5) + (B ^ C ^ D) + E + W[i] + 0x6ED9EBA1) & 0x0ffffffff;
                E = D;
                D = C;
                C = this._rotate_left(B, 30);
                B = A;
                A = temp;
            }
            for (i = 40; i <= 59; i++) {
                temp = (this._rotate_left(A, 5) + ((B & C) | (B & D) | (C & D)) + E + W[i] + 0x8F1BBCDC) & 0x0ffffffff;
                E = D;
                D = C;
                C = this._rotate_left(B, 30);
                B = A;
                A = temp;
            }
            for (i = 60; i <= 79; i++) {
                temp = (this._rotate_left(A, 5) + (B ^ C ^ D) + E + W[i] + 0xCA62C1D6) & 0x0ffffffff;
                E = D;
                D = C;
                C = this._rotate_left(B, 30);
                B = A;
                A = temp;
            }
            H0 = (H0 + A) & 0x0ffffffff;
            H1 = (H1 + B) & 0x0ffffffff;
            H2 = (H2 + C) & 0x0ffffffff;
            H3 = (H3 + D) & 0x0ffffffff;
            H4 = (H4 + E) & 0x0ffffffff;
        }
        var temp = this._cvt_hex(H0) + this._cvt_hex(H1) + this._cvt_hex(H2) + this._cvt_hex(H3) + this._cvt_hex(H4);

        return temp.toLowerCase();

    },

    _rotate_left(n, s) {
        var t4 = (n << s) | (n >>> (32 - s));
        return t4;
    },
    _lsb_hex(val) {
        var str = "";
        var i;
        var vh;
        var vl;
        for (i = 0; i <= 6; i += 2) {
            vh = (val >>> (i * 4 + 4)) & 0x0f;
            vl = (val >>> (i * 4)) & 0x0f;
            str += vh.toString(16) + vl.toString(16);
        }
        return str;
    },
    _cvt_hex(val) {
        var str = "";
        var i;
        var v;
        for (i = 7; i >= 0; i--) {
            v = (val >>> (i * 4)) & 0x0f;
            str += v.toString(16);
        }
        return str;
    },
    _Utf8Encode(string) {
        string = string.replace(/\r\n/g, "\n");
        var utftext = "";
        for (var n = 0; n < string.length; n++) {
            var c = string.charCodeAt(n);
            if (c < 128) {
                utftext += String.fromCharCode(c);
            }
            else if ((c > 127) && (c < 2048)) {
                utftext += String.fromCharCode((c >> 6) | 192);
                utftext += String.fromCharCode((c & 63) | 128);
            }
            else {
                utftext += String.fromCharCode((c >> 12) | 224);
                utftext += String.fromCharCode(((c >> 6) & 63) | 128);
                utftext += String.fromCharCode((c & 63) | 128);
            }
        }
        return utftext;
    },

    getUniverseFromRole(roleName) {
        return roleName.split('-')[0];
    },

    dataURLtoFile(dataurl, filename) {
        if (dataurl != null) {
            var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
                bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
            while (n--) {
                u8arr[n] = bstr.charCodeAt(n);
            }
            return new File([u8arr], filename, {type: mime});
        }
    },

    formatMessages(message) {

        let messageArray = []

        if (this.isObject(message)){
            Object.keys(message).map((objectKey) => {
                if (Array.isArray(message[objectKey])) {
                    message[objectKey].forEach(item => {
                        messageArray.push({message:item,count:router.routeCount});
                    })
                }
                else {
                    messageArray.push({message:message[objectKey],count:router.routeCount});
                }

            })
        }
        else{
            messageArray.push({message:message,count:router.routeCount});
        }


        return messageArray

    },

    isObject(obj) {
        return obj === Object(obj);
    },

    capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    },

    initValueFromType(type){
        switch(type){
            case 'string':
                return ""
            case 'number':
                return 0
            case 'array':
                return []
            case 'list':
                return ""
        }
    },

    checkBills(){
        if(store.state.Papers){
            if (store.state.Papers.clientInfos){
                if(store.state.Papers.clientInfos.isBlocked == 1){
                    // 'Votre compte présente une ou plusieurs irrégularités. Afin d\'éviter une coupure de service, veuillez vous rapprocher rapidement du service administratif (+33247411010)'
                    store.commit('Messages/addError','Votre compte présente une ou plusieurs irrégularités. Afin d\'éviter une coupure de service, veuillez vous rapprocher rapidement du service administratif (+33247411010)');
                } else if(store.state.Papers.clientInfos.isBlocked == 2){
                    //store.commit('UI/showBlocker',true)
                    router.replace({name:'bills'})
                }
            }
        }
    },
    t(key, params) {
        return window.V.$i18n.t(key, params)
    },
    getTheme() {
        if(window.location.host.includes('beepiz')){
            if(window.location.host.includes('sfr')) return "sfr"
            if(window.location.host.includes('catsafe')) return "catsafe"
            return "beepiz";
        }
        return "suividefotte";
    },
    isThemeBeepiz() {
        return this.getTheme() == "beepiz"
    },
    isThemeSfr() {
        return this.getTheme() == "sfr"
    },
    isThemeCatsafe() {
        return this.getTheme() == "catsafe"
    },
    isThemeSuivideflotte() {
        return this.getTheme() == "suividefotte"
    },
    themedUniverses() {

        if (this.isThemeCatsafe()) {
            universes.beepiz.name = "CAT'SAFE"
            universes.beepiz.icon = "CatsafeIcon"
        }
        if (this.isThemeSfr()) {
            universes.beepiz.name = "SFR DATI"
            universes.beepiz.icon = "SfrdatiIcon"
        }

        return universes
    }

    /*can(permissions){
        var temp,
            tKey,
            obj = store.getters['Auth/permissions'],
            multipart = [];


        if (obj) {

            if (permissions.indexOf('||') !== -1) {
                multipart = permissions.split(' || ');
            }
            else {
                multipart.push(permissions);
            }


            var oneOk = false;

            for (var mKey in multipart) {
                if (_indexOf(obj, multipart[mKey]) != -1) {
                    oneOk = true;
                }
            }

            if (oneOk !== true) {
                return false
            }
            else {
                return true
            }


        }
    }*/

}



// WEBPACK FOOTER //
// ./src/services/utils.js